/**
 * 16c.2 (B2cTanitim2, "Mesela bunu Oppy'ye sorun."; D-374): the example a visitor picks on the landing page waits in
 * this tab (sessionStorage, as the sign-up's own step does) until their first signed-in home page puts it in the
 * message box, unsent. It survives the e-mail code step and is never in a URL, a cookie or a request: nothing reaches
 * the server before the person sends it themselves. A closed tab forgets it, like the sign-up itself.
 */
export const LANDING_PROMPT_KEY = 'oppy.prompt';
/** longer than any example: not one of ours */
const MAX_LENGTH = 1000;

type TabStore = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function tabStore(): TabStore | null {
  try {
    return window.sessionStorage;
  } catch {
    // no window (tests) or storage blocked
    return null;
  }
}

export function keepLandingPrompt(text: string, store: TabStore | null = tabStore()): void {
  const value = text.trim();
  if (!store || !value || value.length > MAX_LENGTH) return;
  try {
    store.setItem(LANDING_PROMPT_KEY, value);
  } catch {
    // storage full or blocked: the sign-up goes on without the question
  }
}

/** The question that waits, if any (read only: forget it once it is in the box) */
export function peekLandingPrompt(store: TabStore | null = tabStore()): string | null {
  try {
    const value = store?.getItem(LANDING_PROMPT_KEY)?.trim() ?? '';
    return value && value.length <= MAX_LENGTH ? value : null;
  } catch {
    return null;
  }
}

export function forgetLandingPrompt(store: TabStore | null = tabStore()): void {
  try {
    store?.removeItem(LANDING_PROMPT_KEY);
  } catch {
    // ignore
  }
}
